var qs = require('qs');
var pathToRegexp = require('path-to-regexp');
export default function buildPath(url, params, query) {
    var path = pathToRegexp.compile(url)(params);
    return (query) ? path + "?" + qs.stringify(query, { arrayFormat: 'indices', encode: false }) : path;
}
